import React from 'react';

import { Row } from '~/src/features/center/common/styled';
import * as ST from '~/src/features/center/Form/styled';

interface IProps {
    children: JSX.Element | JSX.Element[],
    withInputName: boolean,
}

const CustomTagRow: React.FC<IProps> = ({ children, withInputName }) => {
    return withInputName ? <ST.RowSlot data-test={'wrapper-slot'}>{children}</ST.RowSlot> : <Row data-test={'wrapper'}>{children}</Row>;
};

export default CustomTagRow;
